import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { EmailRouting, GraduationApi, errorMessage } from '../services/GraduationApi';

export default function ImpersonationEmailControls({ sessionId }: { sessionId: string }) {
  const [routing, setRouting] = useState<EmailRouting | null>(null); const [busy, setBusy] = useState(false);
  const [error, setError] = useState(''); const [message, setMessage] = useState(''); const controller = useRef(new AbortController());
  useEffect(() => {
    const request = new AbortController(); controller.current = request; setRouting(null); setError(''); setMessage(''); setBusy(false);
    void (async () => {
      try { const value = await GraduationApi.emailRouting(request.signal); if (!request.signal.aborted) setRouting(value); }
      catch (e) { if (!request.signal.aborted) setError(errorMessage(e)); }
    })();
    return () => request.abort();
  }, [sessionId]);
  const run = async (work: (signal: AbortSignal) => Promise<void>) => {
    const request = controller.current; setBusy(true); setError(''); setMessage('');
    try { await work(request.signal); } catch (e) { if (!request.signal.aborted) setError(errorMessage(e)); }
    finally { if (!request.signal.aborted) setBusy(false); }
  };
  return <Alert variant={routing?.sendToAdmin === false ? 'warning' : 'info'} className="impersonation-email-controls">
    <strong>Email routing for this impersonation session</strong>
    {routing && <><Form.Check type="switch" id="impersonation-email-test" label="Send triggered emails to me for testing" checked={routing.sendToAdmin} disabled={busy} onChange={e => {
      const enabled = e.target.checked;
      if (!enabled && !window.confirm('Turn off session test routing? Triggered emails will use normal delivery settings and may go to students and staff.')) return;
      void run(async signal => { const result = await GraduationApi.setEmailRouting(enabled, signal); if (!signal.aborted) setRouting(result); });
    }} />
      <p className="mb-2">{routing.sendToAdmin ? `All emails triggered in this session go to ${routing.recipient}.` : 'Emails triggered in this session use the environment’s normal delivery settings.'} Queued emails retain the destination selected when their action occurred.</p>
      <Button size="sm" variant="outline-primary" disabled={busy} onClick={() => void run(async signal => { await GraduationApi.sampleImpersonationEmail(signal); if (!signal.aborted) setMessage('Sample email queued to your administrator account.'); })}>Send sample to me</Button>
    </>}
    {!routing && !error && <p role="status">Checking safe email routing…</p>}
    {error && <p role="alert" className="mb-0">{error}</p>}{message && <p role="status" className="mb-0 mt-2">{message}</p>}
  </Alert>;
}
